import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'
import ForecastGoalProgress from './ForecastGoalProgress'
import UploadSummary from '../UploadSummary'

import { useFetchLineItemAdsForecast } from '../../../hooks/useFetchLineItemAdsForecast'
import { calc } from '../../../../../../../../helpers/numbers'

import { gamRightUploadAdDataSelector } from '../../../../../../../../modules/selectors/rights'

import { UPLOADED_MEDIA_LIST } from '../../../fields'
import { BASE64 } from '../../../../../../../ReusableFormFields/AdFileUpload/fields'

function ForecastSection({ formik }) {
  const { t } = useTranslation()
  const { values } = formik

  const { lineItem } = useSelector(gamRightUploadAdDataSelector)

  const filledUploadedCreatives = useMemo(() => {
    return values[UPLOADED_MEDIA_LIST].filter(item => item[BASE64])
  }, [values])

  const { data: forecastData, isLoading } = useFetchLineItemAdsForecast({
    uploadedCreatives: filledUploadedCreatives
  })

  const lineItemUnits = lineItem?.primary_goal?.units || 0
  const forecastedImpressions = forecastData?.matched_units
  const forecastGoal = calc(forecastedImpressions).div(lineItemUnits).mul(100).toDP(0).toNumber()

  const unlikely = forecastGoal < 50 ? t('very unlikely') : forecastGoal > 90 ? t('likely') : t('may be likely')
  const impressions = lineItem?.primary_goal?.units ? lineItemUnits : 'N/A'

  return (
    <>
      <UploadSummary formik={formik} />
      <ForecastGoalProgress forecastGoal={forecastGoal} isLoading={isLoading} />
      <p>
        {t('With these creatives this line item is {{unlikely}} to deliver its', { unlikely })}{' '}
        {isLoading ? <Skeleton width={25} style={{ display: 'inline-flex' }} /> : impressions} {t('budget')}.
      </p>
    </>
  )
}

export default ForecastSection
